import { c as _c } from "react/compiler-runtime";
import { AFFILIATE_DASHBOARD_API } from 'modules/affiliate-dashboard/api/affiliate-dashboard-api';
import { AffiliateDashboardFilterInterface } from 'modules/affiliate-dashboard/types/affiliate-dashboard-interface';
import { isDefaultFilter } from 'modules/affiliate-program/utils/is-default-filter';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import useSWR from 'swr';
export const useAffiliateDashboardChart = filter => {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  const {
    user
  } = useUser();
  const filterApi = `${filter.dateSince !== null ? `filter[dateSince]=${filter.dateSince}` : ""}${filter.dateTill !== null ? `&filter[dateTill]=${filter.dateTill}` : ""}`;
  let t1;
  if ($[1] !== filter.dateSince || $[2] !== filter.dateTill || $[3] !== filter.vendorId || $[4] !== filterApi || $[5] !== user) {
    t1 = () => {
      if (!user || isDefaultFilter({
        dateSince: filter.dateSince,
        dateTill: filter.dateTill
      }, user.timezone) || !filterApi) {
        return;
      }
      if (filter.vendorId) {
        return `${AFFILIATE_DASHBOARD_API}/chart/${filter.vendorId}?${filterApi}`;
      } else {
        return `${AFFILIATE_DASHBOARD_API}/chart?${filterApi}`;
      }
    };
    $[1] = filter.dateSince;
    $[2] = filter.dateTill;
    $[3] = filter.vendorId;
    $[4] = filterApi;
    $[5] = user;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return useSWR(t1, fetcher);
};